<template>
  <div>
    <b-button variant="warning" class="pull-right"  @click="modalShow = !modalShow">
      <i class="pe pe-money" aria-hidden="true"/>
    </b-button>
    <b-modal v-model="modalShow"
             :title="expenseLabel + ' - Payments'"
             hide-footer
             no-fade
             @hidden="
               SET_MODAL_CLOSED()
               resetForm()"
             @shown="
               SET_MODAL_OPEN()
               focusPaymentAmountField()"
    >
      <div v-if="error" class="alert alert-danger">{{ error }}</div>
      <div v-if="message" class="alert alert-success">{{ message }}</div>

      <div class="form-group row">
        <label for="paymentAmount" class="col-md-4 col-form-label text-md-right">Amount</label>
        <div class="col-md-6">
          <b-input-group :append="state.ledger.selectedLedger.currency | uppercase">
            <input id="paymentAmount"
                   ref="paymentAmount"
                   v-model="form.amount"
                   :class="{ 'is-invalid': errors.amount }"
                   autofocus
                   type="number"
                   pattern="[0-9]*"
                   class="form-control"
                   @keyup.enter="submitPayment()"
            >
          </b-input-group>
          <span v-if="errors.amount" class="invalid-feedback d-block">
            <div v-for="(error, index) in errors.amount" :key="index"><strong>{{ error }}</strong></div>
          </span>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-4 col-form-label text-md-right">Description</label>
        <div class="col-md-6">
          <input v-model="form.description"
                 :class="{ 'is-invalid': errors.description }"
                 type="text"
                 class="form-control"
          >
          <span v-if="errors.description" class="invalid-feedback">
            <div v-for="(error, index) in errors.description" :key="index"><strong>{{ error }}</strong></div>
          </span>
        </div>
      </div>
      <div class="form-group row mb-0">
        <div class="col-md-6 offset-md-4 text-center">
          <button type="submit" class="btn btn-primary" @click.prevent="submitPayment()">
            <span v-if="this.$loading.isLoading('saving-payment')"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span> Add
          </button>
        </div>
      </div>
      <br>
      <div v-for="(item, index) in records" :key="index + '-payment'" class="payments-item">
        <div style="width:100%;display:inline-block">
          <div>{{ item.created_at | formatDateDayMonthShort }} - {{ item.name }} <div class="pull-right">&nbsp;{{ item.amount | formatNumber }} {{ state.ledger.selectedLedger.currency | uppercase }}</div></div>
          <span v-if="item.description"><i class="pe pe-comment-o" aria-hidden="true"/> {{ item.description }}</span>
        </div>
        <div><a v-if="state.account.me && ((state.ledger.selectedLedger.owner_id === state.account.me.id) || (item.created_by === state.account.me.id))" href="#" @click.prevent="removePayment(item.id)"><i class="pe pe-trash-o" aria-hidden="true"/></a></div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  name: 'Payment',
  props: {
    expenseId: {
      required: true
    },
    expenseLabel: {
      required: true
    },
    records: {
      required: true
    }
  },
  data () {
    return {
      modalShow: false,
      form: {
        amount: '',
        description: ''
      },
      message: '',
      error: '',
      errors: {}
    }
  },
  computed: {
    ...mapState({
      state: state => state
    }),
    ledgerId () {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapMutations([
      'SET_MODAL_OPEN',
      'SET_MODAL_CLOSED'
    ]),
    ...mapActions([
      'createPayment',
      'destroyPayment'
    ]),
    focusPaymentAmountField (e) {
      this.resetForm()
      this.$refs.paymentAmount.focus()
    },
    resetForm () {
      this.error = ''
      this.errors = {}
      this.message = ''
      this.form.amount = ''
    },
    submitPayment () {
      this.$loading.startLoading('saving-payment')
      this.errors = {}
      this.createPayment({ 'ledgerId': this.ledgerId, 'expenseId': this.expenseId, 'payment': this.form })
        .then((data) => {
          this.error = ''
          this.form.amount = ''
          this.form.description = ''
          this.message = data.message
          this.$loading.endLoading('saving-payment')
        })
        .catch((data) => {
          this.message = ''
          this.error = data.message
          this.errors = data.errors || {}
          this.$loading.endLoading('saving-payment')
        })
    },
    removePayment (paymentId) {
      let self = this
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        animation: false
      }).then((result) => {
        if (result.value) {
          self.destroyPayment({ 'ledgerId': self.ledgerId, 'expenseId': self.expenseId, 'paymentId': paymentId })
            .then((data) => {
              self.error = ''
              self.message = data.message
            })
            .catch((data) => {
              self.message = ''
              self.error = data.message
            })
        }
      })
    }
  }
}
</script>
